module.exports = __webpack_public_path__ + "img/12.thunder-light.80167c2d.svg";